import {mapState, mapMutations} from "vuex";

export default {
    data() {
        return {
            profile: {
                name: '',
                user_id: '',
                department: '',
                mobile: '',
                email: '',
            },
            sending: false,
        }
    },
    computed: {
        ...mapState(['user', 'process','preset']),
        mobile_rule(){
            return this.$organization.mobile_required ?
                [{ required: true, message: '请输入手机号', trigger: 'blur' }]
                : [];
        },
        email_rule(){
            return this.$organization.email_required ?
                    [ { required: true, message: '请输入邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确格式的邮箱', trigger: 'blur' }]
                : [];
        }
    },
    mounted() {
        this.resetForm();
    },
    methods: {
        ...mapMutations('user', ['setUserInfo']),
        resetForm() {
            this.profile.name = this.user.name;
            this.profile.user_id = this.user.user_id;
            this.profile.department = this.user.department;
            this.profile.mobile = this.user.mobile;
            this.profile.email = this.user.email;
        },
        submitForm() {
            const vm = this;
            this.$refs['profile'].validate((valid) => {
                if (valid) {
                    this.$api('Profile', this.profile, true).then((response) => {
                            vm.setUserInfo(response.data.data);
                            vm.$notify({
                                title: '成功',
                                message: '档案更新完成!',
                                type: 'success'
                            })
                            this.$router.push('/my-meeting');
                        }
                    );
                } else {
                    this.$notify({
                        title: '错误',
                        message: '请按照指示填写正确的信息',
                        type: 'error'
                    });
                    return false;
                }
            });
        },
        sendNoticeEmail() {
            const vm = this;
            vm.$affirm('我们将向管理员发送一封提醒邮件, 是否继续?').then(() => {
                vm.$api('User.Remind', {}, true).then(() => {
                    vm.$messageBox.success('邮件已经发出,请等待管理员回复');
                    setTimeout(function () {
                        vm.sending = false;
                    }, 60000);
                })
            })
        }
    }
}
